import { push, ref, set } from "firebase/database";
import { CashMovementData } from "../../models/cashMovement";
import { db } from "../firebaseConfig";

export const saveCashMovement = async (movement: CashMovementData) => {
	const normalizedVendorName = movement.vendorName?.trim();

	if (!movement.description?.trim()) {
		throw new Error("Description is required for cash movement.");
	}
	if (
		movement.type === "EXPENSE" &&
		movement.expenseCategory === "Stock Purchase" &&
		!normalizedVendorName
	) {
		throw new Error("Vendor/Supplier is required for stock purchase.");
	}

	const cashMovementRef = ref(db, "cashMovements");
	const newCashMovementRef = push(cashMovementRef);
	await set(newCashMovementRef, {
		...movement,
		description: movement.description.trim(),
		...(normalizedVendorName ? { vendorName: normalizedVendorName } : {})
	});
	return newCashMovementRef.key;
};
